export default {
  title: 'Pague as faturas e baixe notas fiscais',
  imgAlt: 'Portal Omie',
  description: 'Precisa de ajuda? Veja como usar o Omie',
  buttonText: 'Acessar Portal Omie',
  urlPortal: `https://portal.omie.com.br/historico-financeiro`,
  urlPortalHelp: 'https://www.youtube.com/watch?v=ARucP1QUSpc',
};
